export default __webpack_public_path__ + "static/media/banner-left.5bbc306a.png";